import { Network } from '@kattana-io/common';
import { store } from '../store/createStore';
import { actionCreateNotification } from '../actions/notifications';

const onCopyAddress = (address: string, e?: any, text?: string) => {
  e?.preventDefault();
  navigator.clipboard
    .writeText(address)
    .then(() => {
      console.log('Copied to clipboard');
      store.dispatch(
        actionCreateNotification({
          kind: 'info',
          message: text || 'Text copied to clipboard',
        })
      );
    })
    .catch((err) => {
      console.warn('Could not copy to clipboard', err);
      store.dispatch(
        actionCreateNotification({
          kind: 'warning',
          message: 'Permission denied',
        })
      );
    });
};

const onTxScan = (tx: string, chain: string, e?: any) => {
  e?.preventDefault();
  const txUrl = Network.fromChain(chain)?.getScan() || '';
  if (txUrl) {
    window.open(`${txUrl}${tx}`);
  }
};

const onWalletScan = (wallet: string, chain: string, e?: any) => {
  e?.preventDefault();
  const walletUrl = Network.fromChain(chain)?.getScanForWallet() || '';
  if (walletUrl) {
    window.open(`${walletUrl}${wallet}`);
  }
};

const onTokenScan = (token: string, chain: string, e?: any) => {
  e?.preventDefault();
  const tokentUrl = Network.fromChain(chain)?.getScanForToken(token) || '';
  if (tokentUrl) {
    window.open(tokentUrl);
  }
};

export { onCopyAddress, onTxScan, onWalletScan, onTokenScan };
